import { AppointmentState } from '@uplift/types';
import { restClient } from '../../client';
import { AppointmentRecurring } from '../../resources';


export type PublicAppointment = {
  timezone: string;
  fromDatetime: string;
  toDatetime: string;
  recurring: AppointmentRecurring;
  state?: AppointmentState;
};


export type PatientCheckInviteTokenOutput = {
  matchId: string;
  patient: {
    id: string;
    email: string;
  };
  appointment?: PublicAppointment;
  providerId: string;
  tokens: {
    access_token: string;
    refresh_token: string;
  };
  error?: string;
};

export const patientCheckInviteToken = (inviteToken: string) => restClient.request<PatientCheckInviteTokenOutput>('/auth/check_invite_link', {
  method: 'POST',
  data: { invite_token: inviteToken },
});
